import { render, staticRenderFns } from "./tagsNav.vue?vue&type=template&id=490348eb&"
import script from "./tagsNav.vue?vue&type=script&lang=js&"
export * from "./tagsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports